/**
 * NotFoundPage -- 404 Catch-All Page
 * Step 9F Green Phase -- Xyden Leadership Assessment Platform
 *
 * Renders when no route matches the current URL.
 */

import React from 'react';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <main className="min-h-[50vh] flex flex-col items-center justify-center text-center p-8">
      <h1 className="text-4xl font-bold text-gray-900 mb-2">404 - Page Not Found</h1>
      <p className="text-sm text-brand-steel mb-8">
        The page you are looking for does not exist or has been moved.
      </p>
      <Link
        to="/content-studio"
        className="px-4 py-2 bg-brand-crimson text-white rounded-lg text-sm font-medium hover:bg-brand-crimson/90"
      >
        Go to Home
      </Link>
    </main>
  );
}

export default NotFoundPage;
